import { Redirect, BrowserRouter as Router, Switch } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Pages from '../Pages';
import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';
import { isUserLoggedSelector, fetchLoggedUser } from '../Redux/LoggedUserSlice';
import { usePermissionsHydration } from '../Hooks/usePermissionsHydration';

export default function Routes() {
  const dispatch = useDispatch();
  const isUserLogged = useSelector(isUserLoggedSelector);
  usePermissionsHydration();

  if (isUserLogged === null) {
    dispatch(fetchLoggedUser());
  }
  return (
    <Router>
      <Switch>
        <Redirect exact from="/" to="/login" />
        <PublicRoute exact path="/test" component={Pages.Test} />
        <PublicRoute exact path="/login" component={Pages.Login} />
        <PrivateRoute exact path="/empresa" component={Pages.Enterprise} />
        <PrivateRoute exact path="/mis-cursos" component={Pages.MyCourses} />
        <PrivateRoute exact path="/cursos" component={Pages.Courses} />
        <PrivateRoute exact path="/cursos/detalles" component={Pages.CourseDetails} />
        <PrivateRoute exact path="/cursos/informacion-de-examen" component={Pages.TestInformation} />
        <PrivateRoute exact path="/cursos/lecciones" component={Pages.Lessons} />
        <PrivateRoute exact path="/cursos/asistencia" component={Pages.Attendance} />
        <PrivateRoute exact path="/empleados" component={Pages.Employees} />
        <PrivateRoute exact path="/cursos/editar" component={Pages.EditCourse} />
        <PrivateRoute exact path="/empleado/desarrollo" component={Pages.EmployeeAssess} />
        <PrivateRoute exact path="/puestos" component={Pages.JobTitles} />
        <PrivateRoute exact path="/definicion" component={Pages.DefinitionCourses} />
        <PrivateRoute exact path="/definicion/empresa" component={Pages.DefinitionCoursesEnterprise} />
        <PrivateRoute exact path="/definicion/departamento" component={Pages.DefinitionCoursesDepartment} />
        <PrivateRoute exact path="/definicion/seleccion/departamento" component={Pages.DefinitionSelectDepartment} />
        <PrivateRoute exact path="/definicion/puesto" component={Pages.DefinitionCoursesJobTitle} />
        <PrivateRoute exact path="/definicion/seleccion/puesto" component={Pages.DefinitionSelectJobTitle} />
        <PrivateRoute exact path="/insignias" component={Pages.Achievements} />
        <PrivateRoute exact path="/departamentos" component={Pages.Departments} />
        <PrivateRoute exact path="/dashboard" component={Pages.Dashboard} />
        <PrivateRoute exact path="/AssignPassword" component={Pages.AssignPassword} />
        <PrivateRoute exact path="/roles" component={Pages.Roles} />
        <PrivateRoute exact path="/roles/crear" component={Pages.RoleCreate} />
        <PrivateRoute exact path="/roles/:id" component={Pages.RoleCreate} />

        {/* Configuración */}
        <PrivateRoute exact path="/configuracion" component={Pages.Settings} />
        <PrivateRoute
          exact
          path="/configuracion/instructores"
          component={Pages.SettingsInstructors}
          requiredPermission="instructor.read"
        />
        {/* Apartir de aquí empieza la refactorización de las ruta */}
        {/* Reportes */}
        <PrivateRoute exact path="/reporte/cursos" component={Pages.CoursesReports} />
        <PrivateRoute exact path="/reporte/cursos/:courseId" component={Pages.CoursesReportsById} />
        <PrivateRoute exact path="/reporte/empleados" component={Pages.EmployeesReports} />
        <PrivateRoute exact path="/reporte/empleados/:employeeId" component={Pages.EmployeesReportsById} />

        {/* Reporte de Sesiones */}
        <PrivateRoute
          exact
          path="/reporte/sesiones/cursos"
          component={Pages.SessionsReports}
          requiredPermission="session.report.read"
        />
        <PrivateRoute
          exact
          path="/reporte/sesiones/empleados"
          component={Pages.SessionEmployeesReports}
          requiredPermission="session.report.read"
        />
        <PrivateRoute
          exact
          path="/reporte/sesiones/:id"
          component={Pages.SessionReportDetail}
          requiredPermission="session.report.read"
        />

        {/* Reporte Historial de Empleados */}
        <PrivateRoute exact path="/reporte/historial/empleados" component={Pages.HistoryReports} />
        <PrivateRoute exact path="/reporte/historial/empleados/:employeeId" component={Pages.HistoryReportsById} />

        {/* Reporte Historial de Cursos */}
        <PrivateRoute exact path="/reporte/historial/cursos" component={Pages.HistoryCoursesReports} />
        <PrivateRoute exact path="/reporte/historial/cursos/:courseId" component={Pages.HistoryCoursesReportsById} />
        {/* Examenes */}
        <PrivateRoute exact path="/cursos/examen/:lessonId" component={Pages.TestStart} />
        {/* Evaluaciones */}
        <PrivateRoute exact path="/cursos/:courseId/lecciones/:lessonId" component={Pages.CoursesLessons} />
        {/* <PrivateRoute exact path="/cursos/:courseId/examenes/:lessonId" component={Pages.TestStart} /> */}
        <PublicRoute path="*" component={Pages.NotFoundPage} />
      </Switch>
    </Router>
  );
}
